import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_MonthlyServiceSummary = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_MonthlyServiceSummary' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Type</span>
                            <input type="text" id="txtContactType" name="txtContactType" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Person(s) Involved</span>
                            <input type="text" id="txtPersonInvolved" name="txtPersonInvolved" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span className='eleHeader'>Consumer Overall Affect</span>
                            <input type="text" id="txtOverallAffect" name="txtOverallAffect" className='add-only' />
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </table>

                <h3>Psychiatric Notes:</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Medication that consumer is currently prescribed:</span>
                            <input type="text" id="txtMedication" name="txtMedication" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is consumer compliant with their meds? Why/why not?</span>
                            <input type="text" id="txtYouthCompliant" name="txtYouthCompliant" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Service Plan Objectives/Interventions:</span>
                    <textarea id="txtYouthTreatmentPlan" name="txtYouthTreatmentPlan" className='add-only'></textarea>
                </p>

                <h2 > <center>DID THE CONSUMER MISS ANY SCHEDULED TIMES:</center></h2>
                <h3>DISCUSSION OF PROGRESS (WEEK 1)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>List the Goals that you worked on this week:
                        What are some things you all worked on this week that stood out? Was there any significant progression or regression? Was there any community linkages? Make sure that it all goes back to the goal and objectives.
                    </span>
                    <textarea id="txtProgress_1" name="txtProgress_1" className='add-only'></textarea>
                </p>

                <h3>DISCUSSION OF PROGRESS (WEEK 2)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>List the Goals that you worked on this week:
                        What are some things you all worked on this week that stood out? Was there any significant progression or regression? Was there any community linkages? Make sure that it all goes back to the goal and objectives.</span>
                    <textarea id="txtProgress_2" name="txtProgress_2" className='add-only'></textarea>
                </p>

                <h3>DISCUSSION OF PROGRESS (WEEK 3)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>List the Goals that you worked on this week:
                        What are some things you all worked on this week that stood out? Was there any significant progression or regression? Was there any community linkages? Make sure that it all goes back to the goal and objectives.</span>
                    <textarea id="txtProgress_3" name="txtProgress_3" className='add-only'></textarea>
                </p>

                <h3>DISCUSSION OF PROGRESS (WEEK 4)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>List the Goals that you worked on this week:
                        What are some things you all worked on this week that stood out? Was there any significant progression or regression? Was there any community linkages? Make sure that it all goes back to the goal and objectives.</span>
                    <textarea id="txtProgress_4" name="txtProgress_4" className='add-only'></textarea>
                </p>

                <h3>DIRECTION OF CONTINUED TREATMENT</h3>
                <p className='w-750'>
                    <span className='eleHeader'>What is the expected direction of treatment? Are you altering the treatment plan? Is there an expected transition or d/c happening soon? What are some additional community linkages that can assist in providing the best treatment for the family?</span>
                    <textarea id="txtContinuedTreatment" name="txtContinuedTreatment" className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>THERAPIST NAME:</span>
                            <input type="text" id="txtTherapistName" name="txtTherapistName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Expected Transition Date</span>
                            <input type="date" id="txtTransitionDate" name="txtTransitionDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Expected D/C Date</span>
                            <input type="date" id="txtDCDate" name="txtDCDate" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> THERAPIST SIGNATURE </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PRINTED NAME OF CLINICAL SUPERVISOR</span>
                            <input type="text" id="txtClinicalSupervisor" name="txtClinicalSupervisor" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> SIGNATURE OF CLINICAL SUPERVISOR </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}